goog.provide('el8.app.shared.dialog.createLabOrderTest');

goog.require('el8.appservice.notifier');
goog.require('el8.template.app.shared.dialog.createLabOrderTest');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.consts');


el8.app.shared.dialog.createLabOrderTest = (function(){

    var saveCallbackFn = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Create New Lab Order Test',
        modal: true,
        position: 'center',
        autoHeight: true,
        width: 350,
        contentFn: el8.template.app.shared.dialog.createLabOrderTest.content
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'testName',
                selector: ':input[name="testName"]',
                infoText: 'new lab test name...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: 100,
                validate: {
                    required: true
                }
            }
        ],
        validationOpts: el8.util.validate.standardOpts
    });

    form.addButton('save', 'Create Lab', function(_form) {
        if (!_form.isValid()) { return; }
        el8.appservice.notifier.notify('Creating new lab test...');
        $.el8_ajax({
            url: el8.service.urls.get('createLabOrderTest'),
            type: 'POST',
            data: JSON.stringify(_form.getMapped(true, true)),
            success: function(data) {
                el8.appservice.notifier.notify('New lab test created.');
                that.hide();
                if (saveCallbackFn) { saveCallbackFn(data); }
            }
        });
    }, true);
    form.addDiscardButton(function() {
        that.hide();
    }, false);
    that.setForm(form);

    var super_show = that.show;
    that.show = function(opts) {
        opts = opts || {};
        
        super_show.call(that);
        if (opts.defaultLabName) {
            form.setVal('testName', opts.defaultLabName);
        }
        saveCallbackFn = opts.saveCb || null;
    };

    return that;
})();
